import { useCallback, useEffect, useState } from "react"
import { apiFetch } from "../../../utils/apiFetch"

const API_BASE =
  (typeof window !== "undefined" &&
  ["localhost", "127.0.0.1", "0.0.0.0"].includes(window.location.hostname)
    ? ["http://localhost", "3000/api"].join(":")
    : "/api")

async function parseJsonSafe(res) {
  try {
    const text = await res.text()
    if (!text) return null
    return JSON.parse(text)
  } catch {
    return null
  }
}

export default function useTreatmentPlansData({
  clinicId,
  initialSearch = ""
}) {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState("")
  const [search, setSearch] = useState(initialSearch)
  const [plans, setPlans] = useState([])

  const [loadingTreatments, setLoadingTreatments] = useState(false)
  const [treatments, setTreatments] = useState([])

  const [loadingPatients, setLoadingPatients] = useState(false)
  const [patientSearch, setPatientSearch] = useState("")
  const [patients, setPatients] = useState([])

  const loadPlans = useCallback(async () => {
    try {
      if (!clinicId) {
        setPlans([])
        setError("No hay una clÃ­nica vÃ¡lida seleccionada.")
        return
      }

      setLoading(true)
      setError("")

      const params = new URLSearchParams({ clinicId })

      if (search.trim()) {
        params.set("q", search.trim())
      }

      const res = await apiFetch(`${API_BASE}/appointments/treatment-plans?${params.toString()}`)
      const data = await parseJsonSafe(res)

      if (!res.ok) {
        setPlans([])
        setError(data?.message || "No se pudieron cargar los planes.")
        return
      }

      setPlans(Array.isArray(data) ? data : [])
    } catch {
      setPlans([])
      setError("Error al cargar los planes.")
    } finally {
      setLoading(false)
    }
  }, [clinicId, search])

  const loadTreatments = useCallback(async () => {
    try {
      if (!clinicId) {
        setTreatments([])
        return
      }

      setLoadingTreatments(true)

      const params = new URLSearchParams({ clinicId })
      const res = await apiFetch(`${API_BASE}/treatments?${params.toString()}`)
      const data = await parseJsonSafe(res)

      if (!res.ok) {
        setTreatments([])
        return
      }

      setTreatments(Array.isArray(data) ? data : [])
    } catch {
      setTreatments([])
    } finally {
      setLoadingTreatments(false)
    }
  }, [clinicId])

  const loadPatients = useCallback(async (searchText = "") => {
    try {
      if (!clinicId) {
        setPatients([])
        return
      }

      setLoadingPatients(true)

      const params = new URLSearchParams({
        clinicId,
        q: searchText || "",
        limit: "50"
      })

      const res = await apiFetch(`${API_BASE}/appointments/clinic-patients?${params.toString()}`)
      const data = await parseJsonSafe(res)

      if (!res.ok) {
        setPatients([])
        return
      }

      setPatients(Array.isArray(data) ? data : [])
    } catch {
      setPatients([])
    } finally {
      setLoadingPatients(false)
    }
  }, [clinicId])

  useEffect(() => {
    const t = setTimeout(() => {
      loadPlans()
    }, 250)

    return () => clearTimeout(t)
  }, [loadPlans])

  useEffect(() => {
    loadTreatments()
  }, [loadTreatments])

  useEffect(() => {
    const t = setTimeout(() => {
      loadPatients(patientSearch)
    }, 250)

    return () => clearTimeout(t)
  }, [loadPatients, patientSearch])

  return {
    loading,
    error,
    search,
    setSearch,
    plans,
    loadPlans,

    loadingTreatments,
    treatments,
    loadTreatments,

    loadingPatients,
    patientSearch,
    setPatientSearch,
    patients,
    loadPatients
  }
}
